import React from "react";
import "./Whatsappbanner.css";

const Whatsappbanner = () => {
    return (
        <>
            <div className="banner_container">
                <div className="banner1">
                    <div className="banner_left">
                        <p>Send Message on</p>
                        <p>9856******</p>
                        <p>to get Latest News</p>
                    </div>
                    <div className="banner_right">
                        <img src="images/whatsapp2.png" alt="Loading" className="right_img" />
                    </div>
                </div>

                <div className="loan_banner">
                <img src="images/homeloan.png" alt="Loading" className="left_img" />
                </div>
            </div>

        </>
    )
}

export default Whatsappbanner;